import { differenceInMilliseconds } from 'date-fns';

import { getToken } from './token';
import { refreshToken } from './requests';
import { Me } from '@/store/auth';

let timeout: number;

export function startTimeoutRefreshToken() {
  const token = getToken();
  if (timeout) clearTimeout(timeout);
  if (token && Me.value) {
    const difference =
      differenceInMilliseconds(new Date(Number(token.expires_at)), new Date()) - 120000;
    if (difference > 0) {
      timeout = setTimeout(() => {
        refreshToken().then(() => {
          startTimeoutRefreshToken();
        });
      }, difference);
    }
  }
}

setTimeout(() => {
  if (Me.value) {
    refreshToken().then(() => {
      startTimeoutRefreshToken();
    });
  }
}, 10000);
